const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Academics', href: '#academics' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
  { label: 'Public Disclosure', href: '#mandatory-public-disclosure' },
];

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <section className="footer-brand" aria-labelledby="footer-school-name">
          <p className="footer-eyebrow">Shri Umiya Patidar Higher Secondary School</p>
          <h2 id="footer-school-name">Learning with purpose. Growing with values.</h2>
          <p>Shree Umiya Patidar Hr. Sec. School, Tillore Khurd, nurtures curious minds through knowledge, character, and community.</p>
        </section>

        <section className="footer-contact" aria-labelledby="footer-contact-title">
          <h2 id="footer-contact-title">Visit Our School</h2>
          <address>
            Ward 14 Village Tillore Khurd<br />
            Dist Indore 452020
          </address>
          <a href="mailto:schoolumiyapatidar@gmail.com">schoolumiyapatidar@gmail.com</a>
        </section>

        <nav className="footer-navigation" aria-labelledby="footer-navigation-title">
          <h2 id="footer-navigation-title">Explore</h2>
          {footerLinks.map((link) => <a href={link.href} key={link.label}>{link.label}</a>)}
        </nav>
      </div>
      <div className="site-footer-bottom">
        <p>© 2026 Shree Umiya Patidar Hr. Sec. School. All rights reserved.</p>
        <a href="#home">Back to top ↑</a>
      </div>
    </footer>
  );
}

export default Footer;
